

































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaBanco from "@/components/bancos/Tabla.vue";
import FormularioBanco from "@/components/bancos/Formulario.vue";
import { DataFormularioBanco } from "@/typings/components/bancos/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoBanco from "@/components/bancos/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  Banco,
  Bancos,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/bancos";
//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";
import CargarBancosExcel from "@/components/excel/CargarBancos.vue";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["bancos"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getBancos: "bancos/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
    getArrayBancos: "bancos/getArray",
  }),
  methods: mapActions({
    setBanco: "bancos/set",
    deleteBanco: "bancos/delete",
    insertBatchBancos: "bancos/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaBanco,
    FormularioBanco,
    InfoBanco,
    //BotonesCrud,
    MensajeEliminar,
    CargarBancosExcel,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
    //TituloVista,
  },
})
export default class VistaBancos extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  banco: Banco | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTE BANCO?";
  dialogoCargarExcel = false;

  get columnasExportacionBancos(): Array<{ label: string; field: string }> {
    return [
      { label: "Nombre", field: "nombre" },
      { label: "Posición", field: "posicion" },
    ];
  }

  get bancos(): Bancos {
    return this.getBancos;
  }

  get items(): Array<Banco> {
    return this.getArrayBancos;
  }

  clickItem(val: { id: string } | null): void {
    this.banco = val ? this.bancos[val.id] : null;
  }

  clickPlus(): void {
    this.banco = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioBanco): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setBanco(doc);
    if (doc.id != this.banco?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Banco creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.banco?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Banco editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.banco = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const banco = this.banco;
    if (!banco?.id) {
      console.error("error id: ", banco);
      return;
    }
    this.deleteBanco(banco.id);
    this.banco = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(banco: Banco): void {
    if (!banco.id) {
      console.error("error id: ", banco);
      return;
    }
    const doc = this.bancos[banco.id];
    if (doc) {
      this.banco = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.banco = null;
  }

  abrirDialogoFormulario(banco: Banco): void {
    if (!banco.id) {
      console.error("error id: ", banco);
      return;
    }
    const doc = this.bancos[banco.id];
    if (doc) {
      this.banco = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(banco: Banco): void {
    if (!banco.id) {
      console.error("error id: ", banco);
      return;
    }
    const doc = this.bancos[banco.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.banco = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.banco = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.banco = null;
  }
}
